import { useLocation } from 'react-router-dom';
import { AppSidebar } from "../AppSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Header } from "../Header";
import { Footer } from "./Footer";
import { PremiumTrialExpiredBanner } from "@/components/notifications/PremiumTrialExpiredBanner";

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  
  const isPublicRoute = (pathname: string) => {
    return pathname === '/' || pathname === '/login' || pathname === '/register';
  };

  const isAdminRoute = (pathname: string) => {
    return pathname.startsWith('/admin');
  };

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full flex-col">
        {!isPublicRoute(location.pathname) && !isAdminRoute(location.pathname) && (
          <>
            <Header />
          </>
        )}
        <div className="flex flex-1">
          {!isPublicRoute(location.pathname) && !isAdminRoute(location.pathname) && <AppSidebar />}
          <main className="flex-1">
            {!isPublicRoute(location.pathname) && !isAdminRoute(location.pathname) && <PremiumTrialExpiredBanner />}
            {children}
          </main>
        </div>
        {location.pathname === '/' && <Footer />}
      </div>
    </SidebarProvider>
  );
};